import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ArrowRightAltOutlinedIcon from '@material-ui/icons/ArrowRightAltOutlined';

const ReportsPage = ({ classes }) => {
  return (
    <div className={classes.wrap}>
      {
        [1,2,3,4,5,6,7,8,9,10].map(()=>{
          return (<Accordion expanded={false} classes={{ root: classes.root }}>
            <AccordionSummary
              expandIcon={<ArrowRightAltOutlinedIcon color="secondary"/>}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography className={classes.heading}>General settings</Typography>
            </AccordionSummary>
          </Accordion>)
        })
      }      
    </div>
  );
};

export default ReportsPage;
